module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "margin-20"
  }, [_c('FilterPageList', {
    attrs: {
      "data": _vm.namespaceList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-select', {
          on: {
            "change": scope.search
          },
          model: {
            value: (_vm.filters.zkAlias.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.zkAlias, "value", $$v)
            },
            expression: "filters.zkAlias.value"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "全部ZK集群",
            "value": ""
          }
        }), _vm._v(" "), _vm._l((_vm.zkClusterKeys), function(item) {
          return _c('el-option', {
            key: item.zkAlias,
            attrs: {
              "label": item.zkAlias,
              "value": item.zkAlias
            }
          })
        })], 2)], 1), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入域名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters.namespace.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.namespace, "value", $$v)
            },
            expression: "filters.namespace.value"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("域信息\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.getAllNamespace
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table-header-separator"
        }), _vm._v(" "), _c('div', [(_vm.$common.hasPerm('registryCenter:batchMoveNamespaces')) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchMigrate()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play-circle text-btn"
        }), _vm._v("批量迁移")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('registryCenter:exportNamespaces')) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleExport()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-circle-o-up text-btn"
        }), _vm._v("导出")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        }, [(_vm.$common.hasPerm('registryCenter:addNamespace')) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleAdd()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle text-btn"
        }), _vm._v("添加域")]) : _vm._e(), _vm._v(" "), (_vm.$common.hasPerm('registryCenter:addNamespace')) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleRefreshCenter()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh text-btn"
        }), _vm._v("刷新注册中心")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-table', {
          ref: "multipleTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "namespace",
            "label": "域名",
            "min-width": "110px",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_overview',
                    params: {
                      domain: scope.row.namespace
                    }
                  }
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                }
              }, [_vm._v("\n                                        " + _vm._s(scope.row.namespace) + "\n                                    ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "描述"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "degree",
            "label": "重要等级",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(_vm.$map.degreeMap[scope.row.degree]) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "version",
            "label": "Executor版本",
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "zkAlias",
            "label": "ZK集群名称",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                attrs: {
                  "placement": "top"
                }
              }, [_c('div', {
                attrs: {
                  "slot": "content"
                },
                slot: "content"
              }, [_vm._v(_vm._s(scope.row.zkAddressList))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.zkAlias))])])]
            }
          }])
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isNamespaceVisible) ? _c('div', [_c('namespace-info-dialog', {
    attrs: {
      "namespace-info": _vm.namespaceInfo,
      "zk-cluster-keys": _vm.zkClusterKeys
    },
    on: {
      "close-dialog": _vm.closeInfoDialog,
      "namespace-info-success": _vm.namespaceInfoSuccess
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isBatchMigrateVisible) ? _c('div', [_c('batch-migrate-dialog', {
    attrs: {
      "batch-migrate-info": _vm.batchMigrateInfo,
      "zk-cluster-keys": _vm.zkClusterKeys
    },
    on: {
      "batch-migrate-complete": _vm.batchMigrateComplete,
      "close-dialog": _vm.closeMigrateDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isMigrateStatusVisible) ? _c('div', [_c('migrate-status-dialog', {
    attrs: {
      "migrate-status-title": _vm.migrateStatusTitle
    },
    on: {
      "close-dialog": _vm.closeMigrateStatusDialog
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8007d9d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/registry_manage/namespace_manage.vue
// module id = 1430
// module chunks = 1